var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItSupportsPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5 31.5H33C32.6022 31.5 32.2206 31.342 31.9393 31.0607C31.658 30.7794 31.5 30.3978 31.5 30V22.5C31.5 22.1022 31.658 21.7206 31.9393 21.4393C32.2206 21.158 32.6022 21 33 21H34.5C35.2956 21 36.0587 21.3161 36.6213 21.8787C37.1839 22.4413 37.5 23.2044 37.5 24V28.5C37.5 29.2956 37.1839 30.0587 36.6213 30.6213C36.0587 31.1839 35.2956 31.5 34.5 31.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 31.5H13.5C12.7044 31.5 11.9413 31.1839 11.3787 30.6213C10.8161 30.0587 10.5 29.2956 10.5 28.5V24C10.5 23.2044 10.8161 22.4413 11.3787 21.8787C11.9413 21.3161 12.7044 21 13.5 21H15C15.3978 21 15.7794 21.158 16.0607 21.4393C16.342 21.7206 16.5 22.1022 16.5 22.5V30C16.5 30.3978 16.342 30.7794 16.0607 31.0607C15.7794 31.342 15.3978 31.5 15 31.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 21V20.25C33.75 17.6641 32.7228 15.1842 30.8943 13.3557C29.0658 11.5272 26.5859 10.5 24 10.5C21.4141 10.5 18.9342 11.5272 17.1057 13.3557C15.2772 15.1842 14.25 17.6641 14.25 20.25V21",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9375 37.875H23.0625C22.5652 37.875 22.0883 37.6775 21.7367 37.3258C21.385 36.9742 21.1875 36.4973 21.1875 36C21.1875 35.5027 21.385 35.0258 21.7367 34.6742C22.0883 34.3225 22.5652 34.125 23.0625 34.125H24.9375C25.4348 34.125 25.9117 34.3225 26.2633 34.6742C26.615 35.0258 26.8125 35.5027 26.8125 36C26.8125 36.4973 26.615 36.9742 26.2633 37.3258C25.9117 37.6775 25.4348 37.875 24.9375 37.875V37.875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8125 36H30C30.7956 36 31.5587 35.6839 32.1213 35.1213C32.6839 34.5587 33 33.7956 33 33V31.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.6902C22.1147 20.1949 22.3988 19.7553 22.8033 19.4473C23.2077 19.1392 23.7071 18.9822 24.215 19.0032C24.7784 18.9723 25.3311 19.1654 25.7526 19.5405C26.1741 19.9155 26.4302 20.4421 26.465 21.0052C26.465 22.5092 24.315 23.0052 24.315 24.0052",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 27.3818C25 27.5807 24.921 27.7715 24.7803 27.9122C24.6397 28.0528 24.4489 28.1318 24.25 28.1318C24.0511 28.1318 23.8603 28.0528 23.7197 27.9122C23.579 27.7715 23.5 27.5807 23.5 27.3818C23.5 27.1829 23.579 26.9922 23.7197 26.8515C23.8603 26.7109 24.0511 26.6318 24.25 26.6318C24.4489 26.6318 24.6397 26.7109 24.7803 26.8515C24.921 26.9922 25 27.1829 25 27.3818Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItSupportsPoi);
export default __webpack_public_path__ + "static/media/it-supports-poi.f7145cf6c707148b9667597410314ceb.svg";
export { ForwardRef as ReactComponent };